import styles from '../../assets/scss/components/layout/main-content.module.scss'
import { classNames } from '@shopify/css-utilities'
import { FC, PropsWithChildren, useContext } from 'react'
import { NotificationBar } from './notification-bar.client'
import { LanguageSwitch } from '../language/language-switch.client'
import { ScrollToTopButton } from '../scroll-to-top-button.client'
import { HeaderContext } from '../header/header-provider.client'
import { PageViewInitializer } from './page-view.client'

export const MainContent: FC<
  {
    hasFooterMargin: boolean
    isLanguageSwitchHidden: boolean
    isScrollToTopEnabled: boolean
    isWhite: boolean
    notificationBarMessage?: string
  } & PropsWithChildren
> = ({ children, hasFooterMargin, isLanguageSwitchHidden, isScrollToTopEnabled, isWhite, notificationBarMessage }) => {
  const { notificationBarBoundingClientRect } = useContext(HeaderContext)

  return (
    <main
      className={classNames(styles.main, hasFooterMargin && styles.hasFooterMargin)}
      style={{ paddingTop: notificationBarBoundingClientRect?.height ?? 0 }}>
      <NotificationBar message={notificationBarMessage} />
      <PageViewInitializer />
      {children}
      <div className={styles.stickyArea}>
        {!isLanguageSwitchHidden && (
          <div className={styles.languageSwitch}>
            <LanguageSwitch isWhite={isWhite} />
          </div>
        )}
        {isScrollToTopEnabled && <ScrollToTopButton />}
      </div>
    </main>
  )
}
